import { CheckboxCard, CompartmentCard } from "@/src/components/cards";
import { ListConstructor } from "@/src/components/fetchableLists";
import SearchKeyHighliter from "@/src/components/seachkeyHighlighter";
import {
  CardType,
  Exam,
  FolderItem,
  Patient,
  SimpleExam,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserShortName, uid } from "@/src/utils/utils";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { useState } from "react";
import { openExamActionsDialog } from "../exams/examActionsDialog";
import { ExamDemandButton } from "../exams/examDemandButton";
import ExamSamplesButton from "../exams/examSamplesButton";

function NurseExamDemandsCompartment({
  color: color,
  patient,
  parent,
}: {
  color: CardType;
  patient: Patient;
  parent: FolderItem;
}) {
  const [reload, setReload] = useState(0);
  let [searchKey, setSearchKey] = useState("");
  let { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["NurseExamDemandsCompartment", searchKey, patient.id, reload],
    queryFn: () =>
      apiFetch(
        "exams",
        "loadMany",
        {
          patientId: patient.id,
          statuses: [
            "pending",
            "inProgress",
            "validated",
            "waitingForValidation",
          ],
          parentId: parent?.id,
        },
        "Erreur lors du chargement des examens"
      ),
  });

  console.log("data", data);

  function getCheckboxStatus(exam: SimpleExam) {
    if (exam.status == "inProgress") return "active";

    if (
      data?.appointments?.find(
        (appointment) => getItemId(appointment.item) == getItemId(exam)
      )
    )
      return "active";
    if ((exam.samples?.length || 0) != 0) return "active";
    return "inactive";
  }

  return (
    <CompartmentCard key={uid()} title={"Examens"} color={color || "orange"}>
      <ListConstructor
        data={data?.exams}
        isLoading={isLoading}
        isError={isError}
        error={error}
      >
        <div className="grid c1 gap10">
          {data?.exams.map((exam, index) => {
            return (
              <CheckboxCard
                key={uid()}
                color={color || "blue"}
                title={
                  <SearchKeyHighliter searchKey={searchKey}>
                    {exam.reference?.name}
                  </SearchKeyHighliter>
                }
                status={getCheckboxStatus(exam)}
                subTitle={getUserShortName(exam?.creator)}
                onClick={async (e) => {
                  e.stopPropagation();

                  if (exam.status == "inProgress") exam.status = "pending";
                  else exam.status = "inProgress";
                  exam = await apiFetch("exams", "addOne", {
                    exam: exam as Exam,
                  });
                  setReload(reload + 1);

                  // await openExamActionsDialog({
                  //   allAppointments: data?.appointments || [],
                  //   exams: data?.exams!,
                  //   index,
                  //   patient,
                  //   services: data?.services || [],
                  //   onChange: async () => {
                  //     setReload(reload + 1);
                  //   },
                  // });
                }}
                // onEdit={async () => {
                //   let appointment = data?.appointments?.find(
                //     (appointment) =>
                //       appointment.item?.id == exam.id ||
                //       appointment.item == exam.id
                //   );
                //   if (!appointment) throw new Error("Appointment not found");
                // }}
              >
                <div className="c1 gap10">
                  <div className="gray">
                    {moment(exam?._date).format("LL HH:mm")}
                  </div>
                  <ExamDemandButton
                    key={uid()}
                    patient={patient}
                    exam={exam}
                    isHospitalized={true}
                    allAppointments={data?.appointments || []}
                    allServices={data?.services || []}
                    onChange={async () => {
                      setReload(reload + 1);
                    }}
                  ></ExamDemandButton>
                  <ExamSamplesButton
                    patient={patient}
                    exam={exam}
                    onChange={async () => {
                      setReload(reload + 1);
                    }}
                  ></ExamSamplesButton>
                </div>
              </CheckboxCard>
            );
          })}
        </div>
      </ListConstructor>
    </CompartmentCard>
  );
}
export { NurseExamDemandsCompartment };
